// 🔧 content_statuses.js
// ✅ Purpose: Defines canonical Content Engine workflow statuses
// ✅ Features:
// - Supports draft, review, published, and archived content lifecycle
// - Keeps publishing and review workflows consistent across the Content Engine

export const CONTENT_STATUSES = {
  DRAFT: "draft",
  REVIEW: "review",
  PUBLISHED: "published",
  ARCHIVED: "archived",
};

export const CONTENT_STATUS_LABELS = {
  [CONTENT_STATUSES.DRAFT]: "Draft",
  [CONTENT_STATUSES.REVIEW]: "In Review",
  [CONTENT_STATUSES.PUBLISHED]: "Published",
  [CONTENT_STATUSES.ARCHIVED]: "Archived",
};